import { Link } from "react-router-dom";
import { categoryMeta } from "@/mocks/films";
import { getAllFilms } from "@/lib/films";

export default function CategoryEntries() {
  const allFilms = getAllFilms();

  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">分类快捷入口</h2>
          <p className="mt-2 text-sm text-foreground-600">按内容形态快速进入，电影、电视剧、网络剧一站浏览。</p>
        </div>
        <Link to="/category/all" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-600 hover:text-accent-700">
          查看全部影视
          <i className="ri-arrow-right-line text-base" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categoryMeta.map((meta) => {
          const count = allFilms.filter((film) => film.category === meta.key).length;
          return (
            <Link
              key={meta.key}
              to={`/category/${meta.key}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${meta.icon} text-2xl`} />
              </span>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{meta.name}</h3>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">{count} 部</span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{meta.description}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-accent-600">
                  进入栏目
                  <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}